import './Batches.css';

import {
    Snack, Snackbar, Text
} from "@nike/eds";
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { BatchTable } from '../components/batch_table/BatchTable';
import { ConfirmationModal } from '../components/confirmation_model/ConfirmationModal';
import { FlushFilingPacksConfirmationModal } from '../components/flush_filing_packs_confirmation_modal/FlushFilingPacksConfirmationModal';
import { ActionContainer } from '../components/action_container/ActionContainer';
import { selectNotification, toggleNotification, findExceptions, selectExceptionsLoaded } from '../shared/store/reducers/OverviewReducer';
import { StoreDispatch } from '../shared/store/Store';
import { Notification } from '../shared/Types';

export function Batches() {
    const dispatch: StoreDispatch = useDispatch();

    const notification: Notification = useSelector(selectNotification);
    const exceptionsLoaded: boolean = useSelector(selectExceptionsLoaded);

    useEffect(() => {
        if (!exceptionsLoaded) {
            dispatch(findExceptions());
        }
    }, [dispatch, exceptionsLoaded]);

    const onClickDismissSnack = () => {
        dispatch(toggleNotification(null));
    }

    return (
        <div id="main-container">
            <span className="button-container">
                <Text font={"title-3"} as={"h3"} className={"eds-spacing--my-24"}> Batches </Text>
            </span>
            <Snackbar>
                {notification && (
                    <Snack id="snack" status={notification.status} onDismiss={onClickDismissSnack} autoDismissDuration={15000}>
                        <p className="eds-type--body-2">{notification.message.replace(/^.+?(:) /, '')}</p>
                    </Snack>
                )}
            </Snackbar>
                <>
                    <ActionContainer/>
                    <BatchTable/>
                    <ConfirmationModal/>
                    <FlushFilingPacksConfirmationModal/>
                </>
        </div>
    )
}